import React from "react"

import { AppFuelPolicyAutocomplete } from "@components/Autocomplete"
import { fuelPolicy } from "@signals"
import { BACKEND_APIS } from "@constants"
import { chainFinish } from '@components/NewCommonFilters/@services/chainFinish'


export default function AppCommonFiltersFuelPolicyAutocomplete({ onOptions, onFinishAjax, ...props }) {
	return <AppFuelPolicyAutocomplete
		value={fuelPolicy.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/fuel`}
		onChange={e => fuelPolicy.value = e.target.value}
		onFinishAjax={chainFinish(onFinishAjax, onOptions)}
		{...props}
	/>
}